import { IconButton, Link } from 'components/Blocks';
import { MenuIcon } from 'components/Blocks/Icons';

import { useAppWrapper } from './WrapperContext';
import { LogoWithText } from 'components/Logos';

export function Header() {
  const { toggleSideBar, showMobileSidebar } = useAppWrapper();

  if (!showMobileSidebar) return null;

  return (
    <header className="z-2 relative flex flex-shrink-0 items-center justify-between bg-primary p-4 text-primary-foreground shadow-md">
      <Link to="home">
        <LogoWithText />
      </Link>

      <IconButton onClick={toggleSideBar}>
        <MenuIcon size={24} />
      </IconButton>
    </header>
  );
}
